export const getDifferenceBetweenTwoDates = (startTime, endTime) => {
    const start = new Date(startTime).getTime();
    const end = new Date(endTime).getTime();

    if (!isNaN(start) && !isNaN(end)) {
        const timeDifference = end - start;
        const seconds = Math.floor((timeDifference / 1000) % 60);
        const minutes = Math.floor((timeDifference / 1000 / 60) % 60);
        const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

        let result = 'Опубліковано ';
        if (days > 0) {
            result += `${days}д `;
        }
        if (hours > 0) {
            result += `${hours}год `;
        }
        if (minutes > 0) {
            result += `${minutes}хв `;
        }
        result += `${seconds}с тому`;

        return result;
    } else {
        return "Invalid date";
    }
}